import Welcome from "./components/Welcome.js";
import AboutMe from "./components/AboutMe.js";
import Experience from "./components/Experience.js";
import Projects from "./components/Projects";
import Project from "./components/Project";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import { useState, useEffect } from "react";

function App() {
  const [lenguaje, setLenguaje] = useState("eng");

  const cambiarLenguaje = () => {
    if (lenguaje == "esp") setLenguaje("eng");
    else setLenguaje("esp");
  };

  return (
    <>
      <Project lenguaje={lenguaje} />
      <button id="languageButton" onClick={() => cambiarLenguaje()}>
        {lenguaje == "eng" ? "Español" : "English"}
      </button>
      <Navbar lenguaje={lenguaje} />
      <div className="outer-wrapper">
        <div className="container">
          <Welcome lenguaje={lenguaje} />{" "}
          {/* Shows my name and welcomes the visitor */}
          <section id="aboutme">
            <AboutMe lenguaje={lenguaje} />
          </section>
          <section id="experience">
            <Experience lenguaje={lenguaje} />
          </section>
          <section id="projects">
            <Projects lenguaje={lenguaje} />
          </section>
          <section id="contactme">
            <Contact lenguaje={lenguaje} />
          </section>
        </div>
      </div>
    </>
  );
}

export default App;
